function initDropdownButton(el) {
    const CUR_ELS = {
        contentEl: null,
        switcherEl: null,
        childEls: null
    };

    function hideDropdown() {
        CUR_ELS.contentEl.classList.remove('_show');
        CUR_ELS.switcherEl.classList.remove('_active');
        document.removeEventListener('click', outsideClick); // eslint-disable-line

        setTimeout(() => {
            CUR_ELS.contentEl.classList.remove('_up');
        }, 300);
    }

    function showDropdown() {
        CUR_ELS.contentEl.classList.add('_up');
        CUR_ELS.contentEl.classList.add('_show');
        CUR_ELS.switcherEl.classList.add('_active');
    }

    function outsideClick(e) {
        if (e.target === CUR_ELS.contentEl || CUR_ELS.contentEl.contains(e.target)) {
            return;
        }

        hideDropdown();
    }

    CUR_ELS.contentEl = el.querySelector('.js-dropdown-content');
    CUR_ELS.switcherEl = el.querySelector('.js-dropdown-switcher');
    CUR_ELS.childEls = el.querySelectorAll('.u-btn-dropdown__item');

    if (CUR_ELS.contentEl) {
        CUR_ELS.switcherEl.addEventListener('click', (e) => {
            e.preventDefault();

            if (CUR_ELS.contentEl.classList.contains('_show')) {
                hideDropdown();
            } else {
                showDropdown();
                setTimeout(() => {
                    document.addEventListener('click', outsideClick);
                }, 200);
            }
        });

        CUR_ELS.childEls.forEach((item) => {
           item.addEventListener('click', () => {
               hideDropdown();
           });
        });
    }
}

export default function dropdownButton() {
    const dropdownEls = document.querySelectorAll('.js-dropdown-button');

    if (dropdownEls.length) {
        dropdownEls.forEach((el) => {
            initDropdownButton(el);
        });
    }
}
